import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import TableNotes from "./TableNotes";
import { useEffect, useState } from "react";

export default function Notes({ setData, initialState }) {
  const [show, setShow] = useState(false);
  const initialNotesData = initialState?.project_job_enquiry_note;
  const [allNotes, setAllNotes] = useState(initialNotesData || []);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      notes_edit: allNotes
        ?.filter((data) => data?.type != "new")
        ?.map((data) => ({
          notes_id: data?.id,
          description: data?.description,
        })),
      notes_new: allNotes
        ?.filter((data) => data?.type == "new")
        ?.map((data) => ({ description: data?.description })),
    }));
  }, [allNotes]);

  const addNote = () => {
    const newNote = {
      id: Math.floor(Math.random() * 100000),
      description: "",
      type: "new",
    };
    setAllNotes((prevState) => [...prevState, newNote]);
  };

  return (
    <div className="flex flex-wrap  gap-4 ">
      <div className="max-w-sm min-w-max  w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Notes</h2>
          <p>Provide notes.</p>
        </div>
      </div>
      <div
        className={`w-full m-2 overflow-hidden px-4 rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <div className="flex justify-between p-3">
          <button
            type="button"
            className="bg-red text-white p-2 rounded-md mt-2 ml-2"
            onClick={addNote}
          >
            + Add Another
          </button>
        </div>
        <TableNotes
          setData={setData}
          allNotes={allNotes}
          setAllNotes={setAllNotes}
        />
      </div>
    </div>
  );
}
